import { LanguageService } from '@/services';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Case } from 'src/app/models/case';
import { ListColumnConfig } from 'src/app/models/listColumnConfig';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CaseService } from 'src/app/services/case/data/case.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
    selector: 'app-cases',
    templateUrl: './cases.component.html',
    styleUrls: ['./cases.component.scss'],
    standalone: false
})
export class CasesComponent implements OnInit {
  data: any;
  addBtn: boolean = false;
  title: string;
  columns: ListColumnConfig[] = [
    {
      id: 'title',
      name: `titel`,
      width: 'auto',
      sort: true,
      keepEnabledWhenLocked: true,
    },
  ];

  isUserSuperAdmin: boolean;

  constructor(
    private caseService: CaseService,
    private authService: AuthService,
    private router: Router,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private matDialog: MatDialog,
    private languageService: LanguageService
  ) {
    this.columns[0].name = this.languageService.translate('general.words.title');
  }

  ngOnInit(): void {
    this.title = this.languageService.translateWithCap('case.title');
    this.isUserSuperAdmin = this.authService.isUserSuperAdmin();
    this.caseService.getBasicCases(false).subscribe(
      resp => {
        this.data = resp as Case[];
        for (let c of this.data) {
          if (!this.isUserSuperAdmin) {
            c.locked = c.lockedByAdmin;
          }
        }
        if (this.authService.isUserTeacher()) {
          this.columns.push({
            id: 'edit',
            name: this.languageService.translate('general.words.edit'),
            width: '80px',
            icon: {
              name: 'edit',
              color: '#5C739D',
            },
          });
          this.columns.push({
            id: 'workgroups',
            name: this.languageService.translate('general.words.workgroups'),
            width: '100px',
            icon: {
              name: 'groups',
              color: '#5C739D',
            },
            keepEnabledWhenLocked: true,
          });
          this.addBtn = true;
        }
        if (this.authService.isUserAdmin()) {
          this.columns.push({
            id: 'delete',
            name: this.languageService.translate('general.words.delete'),
            width: '100px',
            icon: {
              name: 'delete',
              color: 'red',
            },
            confirmDelete: true,
          });
          this.addBtn = true;
        }
      },
      err => this.errorService.onError(err)
    );
  }

  onRowClick(event: any) {
    this.router.navigateByUrl(`casussen/${event.id}`);
  }

  onColumnActionClick(event: any) {
    if (event.column == 'edit') this.router.navigateByUrl(`casussen/${event.row.id}/wijzigen`);
    if (event.column == 'delete') {
      this.caseService.setCaseInactive(event.row.id).subscribe(
        resp => {
          this.caseService.getBasicCases(false).subscribe(
            resp => {
              this.notificationService.success(
                this.languageService.translate('case.notifications.delete.success.message', {
                  TITLE: event.row.title,
                })
              );
              this.data = resp as Case[];
            },
            err => this.errorService.onError(err)
          );
        },
        err => this.errorService.onError(err)
      );
    }
    if (event.column == 'workgroups') this.router.navigateByUrl(`casussen/${event.row.id}/werkgroepen`);
  }

  onAddClick() {
    this.router.navigateByUrl(`casussen/nieuw/wijzigen`);
  }
}
